import React from "react";
import { Pressable } from "react-native";
import tw from "twrnc";
import Text from "./AppText";
import { t } from "@/localization";

export const ForgotPasswordLink = ({ onPress }) => {
  return (
    <Pressable
      onPress={onPress}
      role="link"
      style={tw`mt-[10px] mb-[10px] flex-row justify-end`}
    >
      <Text multiline={false} style={[tw`font-bold text-[#2E3F52]`]}>
        {t("Forgot password?")}
      </Text>
    </Pressable>
  );
};
